<template>
	<window-view title="Klient" v-on="$listeners" :width="600" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.new_id" label="ID" />
				</grid-view>
				<grid-view>
					<input-view v-model="m.username" label="Brugernavn" />
				</grid-view>
				<grid-view>
					<input-view v-model="m.password" label="Adgangskode" />
				</grid-view>
				<grid-view>
					<input-view v-model="m.note" label="Note" />
				</grid-view>
				<grid-view>
					<input-view v-model="m.email" label="E-mail" />
				</grid-view>
				<grid-view>
					<select-view v-model="m.update_version" :options="_versions" label="Opdater til" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import client from '../../../model/client';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				versions: [],
				id: '',
				m: client.model()
			};
		},
		computed: {
			_versions() {
				let r = [
					{
						label: 'Ingen',
						value: 1
					}
				];

				return r.concat(this.versions.map((row) => {
					return {
						label: row.id,
						value: row.id
					};
				}));
			},
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
			this.m.new_id = this.model.id;

			this.versions = (await this.axios.get(`/versions`)).data;
		}
	}
</script>

<style lang="scss" scoped>

</style>